import styled from 'styled-components';
import darkTheme from 'src/config/darkTheme';
import ButtonBase from '@mui/material/ButtonBase';

// darkTheme.palette.secondary.main;

export const Container = styled(ButtonBase)`
  position: relative;
  cursor: pointer;
  width: 100%;
  display: block;
  &:hover .overlay {
    display: flex;
  }
`;

export const MissingImageContainer = styled.div`
  background-color: #193247;
  height: 162px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
`;

export const ThumbContainer = styled.div`
  height: 100%;
  overflow: hidden;
  border-radius: 4px;
`;
export const ThumbImage = styled.img`
  height: 162px;
  width: 100%;
  object-fit: cover;
  border-radius: 4px;
`;

export const ThumbOverlay = styled.div.attrs({
  className: 'overlay',
})`
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 162px;
  background-color: rgba(12, 23, 33, 0.6);

  justify-content: center;
  align-items: center;
  & .MuiButtonBase-root {
    background-color: ${darkTheme.palette.background.paper};
    width: 40px;
    height: 40px;
    border-radius: 40px;
  }
`;

export const NoImage = styled.div``;

export const Progress = styled.div`
  position: absolute;
  /* bottom: 0; */
  right: 0;
  top: 130px;
  background-color: #ff0000;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #13dea1;
  padding: 4px 10px;
  color: #0c1721;
  border-radius: 10px 0px 0px 0px;
  gap: 4px;
  & .status {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
  }
  & .count {
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
`;
